import { isDev } from '../utils';

export const groupEvents = [
  {
    id: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'New Year Starts Now',
    title: 'Close out 2022 and begin 2023 with intentional habits, plus a strategy to sustain them.',
    description: 'Close out 2022 and begin 2023 with intentional habits, plus a strategy to sustain them.',
    features: [
      {
        title: '4 weekly interactive workshops and discussion groups',
        description: 'We’ll cover topics from “Goal Setting” to “Integrating Consistency,” while sharing and learning with a vibrant community.',
      },
      {
        title: 'Private, members-only podcast access',
        description: 'With 2 bonus discussions to help you reflect on 2022 and prepare for 2023.',
      },
      {
        title: 'Program dashboard and habit tracker',
        description: 'Monitor your progress in a personal dashboard and stay accountable to your 2023 goals. ',
      },
    ],

    startDate: '2022-12-26T17:00:00-06:00',
    endDate: '2023-01-30T17:00:00-06:00',
    startTimestamp: 1675119600,
    endTimestamp: 1675119600,
    timezone: 'US/Central',
    allowFreeMembers: 'TRUE',
    allowSprout: 'TRUE',
    allowBloom: 'TRUE',
    eventType: 'SMALL_GROUP',
    attendeeLimit: 60,
    price: 29,
    hostFirstName: 'Claire',
    hostLastName: 'Siegel',
    hostEmail: 'claire@weflourish.com',
    hostWebsite: 'https://weflourish.com',
    hostAvatar: 'https://cdn.weflourish.com/images/coaches/claire_siegel.png',
    featureImageUrl: 'https://cdn.weflourish.com/images/backgrounds/holiday-2022.jpeg',
    metadata: {
      stripeProductId: isDev() ? 'prod_Mz0dv9Ixn3Iwut' : 'prod_Mz0dv9Ixn3Iwut',
      stripePriceId: 'small-group',
      eventLandingPageUrl: 'https://weflourish.com',
      eventMeetingLink: 'https://weflourish.com',
      activeCampaignTagId: 385,
    },
  },
];

export const groupEventSessions = [
  {
    id: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    sessionTitle: 'New Year Starts Now',
    sessionDescription: 'New Year Starts Now',
    startDate: '2022-12-26T17:00:00-06:00',
    endDate: '2023-01-30T17:00:00-06:00',
    startTimestamp: 1675119600,
    endTimestamp: 1675119600,
    timezone: 'US/Central',
    allowFreeMembers: 'TRUE',
    allowSprout: 'TRUE',
    allowBloom: 'TRUE',
    isRecurring: 'TRUE',
    attendeeLimit: 60,
    metadata: {
      chatChannelId: 'SGDC-2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
      eventSessionLandingPageUrl: 'https://weflourish.com',
      eventSessionMeetingLink: 'https://wefourish.com',
      actuityAppointmentTypeId: '39646340',
      acuityCalendarId: '7534384',
      activeCampaignTagId: 379,
    },
  },
];

export const eventSessionTimes = [
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 1',
    title: 'Where you’ve been: 2022 in review',
    description: 'In this pre-recorded session, Claire will guide you through a year-end reflection that will create the foundation for next year’s goals.',
    startDate: '2022-12-26T17:00:00-06:00',
    endDate: '2022-12-26T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 2',
    title: 'Where you are: Habit & identity audit',
    description:
      'Through this pre-recorded session, you’ll create neutral awareness of the thought and behavior patterns you’ll be leaving behind in the new year.',
    startDate: '2023-01-02T17:00:00-06:00',
    endDate: '2023-01-02T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 3',
    title: 'Goal setting with Claire',
    description: 'Set clear goals and a strategy to sustain them! You’ll walk away from this workshop with a plan you feel confident in.',
    startDate: '2023-01-09T17:00:00-06:00',
    endDate: '2023-01-09T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 4',
    title: 'New year, new mindset with Julie',
    description:
      'Our thoughts play such a significant role in the journey of approaching new habits. In this session, we’ll learn about unhelpful thought patterns and how to shift into more productive thinking styles that will support your goals. ',
    startDate: '2023-01-16T17:00:00-06:00',
    endDate: '2023-01-16T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 5',
    title: 'Sustainable approaches with Elizabeth',
    description:
      'Being taught unsustainable approaches to change are why many of us find ourselves in Flourish. Join this session to workshop the integral necessities of taking a truly sustainable approach to change.',
    startDate: '2023-01-23T17:00:00-06:00',
    endDate: '2023-01-23T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    eventId: 'b4b028b8-cfe6-4bb3-bbd9-de71831fee32',
    name: 'Week 6',
    title: 'Integrating consistency with Libby',
    description:
      'Maintaining the moment of change can be a challenge. For this session, Libby will walk you through the strategies and tips of approaching consistency so you aren’t back where you started come 2024!',
    startDate: '2023-01-30T17:00:00-06:00',
    endDate: '2023-01-30T18:00:00-06:00',
    timezone: 'America/Chicago',
    type: 'WORKSHOP',
    metadata: {
      acuityCalendarId: '7534384',
      acuityAppointmentTypeId: '39646340',
      meetingLinkVideo: 'https://us02web.zoom.us/j/9524208426',
      meetingLinkAudio: null,
      recordingLink: null,
    },
  },
];

export const groupEventSessionFacilitators = [
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    coachId: 'a865d929-13e8-46d9-b4e7-4ab59776037c',
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    coachId: 'dd9084f8-dd22-4e41-b36b-589858703a47',
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    coachId: '1680b9c8-b843-4a84-84dd-81007b9b4957',
  },
  {
    eventSessionId: '2f1891b7-dc5a-4e76-97a6-f3d509cc5370',
    coachId: '4fc09110-3cd6-4859-86d9-632cfe6c157d',
  },
];
